'use client';

import React from 'react';
import LoadingScreen from '@/components/ui/LoadingScreen';

export default function AppLoading() {
  return <LoadingScreen labelKey="app.initializing" defaultLabel="Inicializando aplicación…" />;
}
